import { DropdownMenuItem, DropdownMenuSeparator } from '@repo/ui';
import { KeyRound } from 'lucide-react';
import { Link } from 'react-router';

import { APP_ROUTES } from '@/constants/app-routes';

export function MyAccessMenuItem() {
  return (
    <>
      <DropdownMenuItem asChild>
        <Link to={APP_ROUTES.myAccess}>
          <KeyRound className="size-4" aria-hidden />
          My access
        </Link>
      </DropdownMenuItem>

      <DropdownMenuSeparator />
    </>
  );
}
